export default {
	publishedPosts: "Opublikowane wpisy",
	changePhoto: "Zmień zdjęcie w tle",
	completedTrainings: "Ukończonych szkoleń",
	certificates: "Certyfikatów",
	groups: "Grupy",
	myGroups: "Moje grupy",
	publicGroups: "Publiczne grupy użytkownika",
	groupCount: "członków w grupie",
	goThrough: "Przejdź",
	profile: "Profil",
	jobPosition: "Stanowisko",
	loading: "Wczytywanie",
	noPosts: "Użytkownik nie ma postów",
	noMorePosts: "Nie ma więcej postów",
};
